import React from 'react'
import { Container, Carousel } from '../../../components'
import { Link } from 'react-router-dom'
import { Card } from '../../blog/components'
import { useViewport, viewportBreakpoint } from '../../../utils'
import data from '../../../database/blog.json'

const MobileComponent = () => {
  return (
    <Container className="py-10">
      <h3 className="text-center font-accent mb-5">Related Posts</h3>

      {/* Cards */}
      <div className="-mx-2 text-gray-900 h-full">
        <Carousel slidesToShow={2} slidesToScroll={2} >
          {
            data.map((d, index) => (
              <div className="w-1/2 px-2 h-full" key={index}>
                <Link to={`/blog/detail/${d.id}`}>
                  <Card data={d}/>
                </Link>
              </div>
            ))
          }
        </Carousel>
      </div>
    </Container>
  )
}

const DesktopComponent = () => {
  return (
    <Container className="py-20">
      <h3 className="font-accent text-4xl mb-10">Related Posts</h3>

      <div className="flex flex-wrap -mx-4">
        {
          data.slice(0,4).map((d, index) => {
            return (
              <div className="w-1/4 px-4 mb-8" key={index}>
                <Link to={`/blog/detail/${d.id}`}>
                  <Card data={d}/>
                </Link>
              </div>
            )
          })
        }
      </div>
    </Container>
  )
}

const RelatedPosts = () => {
  const { width } = useViewport()
  const isMobile = width < viewportBreakpoint.tablet
  return isMobile ? <MobileComponent /> : <DesktopComponent />
}

export { RelatedPosts }